import { UNIQUE_ROLES } from 'clickNgo/entities/contact'
import { IContact } from 'clickNgo/entities/contact'

export function renderHpRolesColumn(contact: IContact) {
  if (contact.hpRoles.length === 0) {
    return <span>-</span>
  }

  return contact.hpRoles.map((role, index) => {
    const hasPrevElement = Boolean(index)

    if (UNIQUE_ROLES.includes(role)) {
      return (
        <span key={role}>
          {hasPrevElement && ', '}
          <strong>{role}</strong>
        </span>
      )
    }

    return (
      <span key={role}>
        {hasPrevElement && ', '}
        {role}
      </span>
    )
  })
}
